import { RelationshipV2 } from 'support/types';
import { StepStatus } from 'components/Display/Steps/Steps';

export type StepStage = 'configuration' | 'tasks' | 'testing' | 'goLive' | 'done' | 'terminated';

const STATUS_TO_STAGE: Record<RelationshipV2['status'], StepStage> = {
  PARTNER_APPROVAL_PENDING: 'configuration',
  PARTNER_ONBOARDING_PENDING: 'configuration',
  PARTNER_INTEGRATION_PENDING: 'configuration',
  PARTNER_PROCESS_PENDING: 'configuration',
  ISSUE_RESOLVER_PENDING: 'configuration',
  LIVE_ORDER_NEEDED: 'configuration',
  TASKS_PENDING: 'tasks',
  READY_FOR_TESTING: 'testing',
  HAS_TEST_MESSAGES: 'testing',
  IN_REVIEW: 'testing',
  GO_LIVE_DATE_PENDING: 'goLive',
  GO_LIVE_DATE_SCHEDULED: 'goLive',
  ACTIVE: 'goLive',
  LIVE: 'done',
  REJECTED: 'terminated',
  DEACTIVATED: 'terminated',
  BLOCKED: 'terminated',
};

export const getStepStage = (status: RelationshipV2['status']): StepStage => STATUS_TO_STAGE[status];

export const getStepStatus = (
  stepStage: StepStage,
  currentStage: StepStage,
  stageOrder: Array<StepStage>,
): StepStatus => {
  if (currentStage === 'terminated') {
    return 'disabled';
  }

  if (currentStage === 'done') {
    return 'completed';
  }

  const stepIndex = stageOrder.indexOf(stepStage);
  const currentIndex = stageOrder.indexOf(currentStage);

  if (currentIndex > stepIndex) {
    return 'completed';
  }

  if (currentIndex === stepIndex) {
    return 'current';
  }

  return 'upcoming';
};
